import { Component } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { ControlValidationMessagesService } from './control-validation-messages.service';
import { BaseComponent } from '../base-components/base.component';

@Component({
    selector: 'control-validation-messages',
    inputs: ['controlName: control', 'formGroup', 'customizeErrorMessage'],
    templateUrl: './control-validation-messages.html'
})
export class ControlValidationMessages extends BaseComponent {
    public controlName: string;
    public formGroup: UntypedFormGroup;
    public customizeErrorMessage: boolean;

    constructor(private _formDir: FormGroupDirective) {
        super();
    }

    public ngOnInit() {
    }

    public get errorMessage() {
        // Find the control in the Host (Parent) form
        let c = this._formDir.form.get(this.controlName);
        if (c == null || c == undefined) {
            // try to get it another way
            const c1 = this._formDir.form.controls[this.controlName];
            if (c1 != undefined && c1 != null) {
                c = c1;
            }
        }

        if (c == undefined) {
            throw new Error('A control named ' + this.controlName + ' could not be found on the page and will not be bound to the validation control');
        } else {

            for (const propertyName in c.errors) {
                // If control has a error
                if (c.errors.hasOwnProperty(propertyName) && c.touched) {
                    // Return the appropriate error message from the Validation Service
                    if (!this.customizeErrorMessage) {
                        return ControlValidationMessagesService.getValidatorErrorMessage(propertyName);
                    } else {
                        return ControlValidationMessagesService.getCustomErrorMessage(propertyName, this.controlName);
                    }
                }
            }
        }

        return null;
    }
}
